import { TestIdClassNameProps } from "@app/types/Common";
import useCerosScript from "@hooks/useCerosScript";
import cx from "classnames";

export type DynamicIframeProps = TestIdClassNameProps & {
  source: string;
  annotation: string;
};

export default function DynamicIframe({
  testId,
  rootClassName,
  source,
  annotation,
}: DynamicIframeProps) {
  useCerosScript();

  const sourceData = JSON.parse(source);
  const paddingBottom = sourceData ? sourceData.data[6].value : "";

  return (
    <>
      {sourceData ? (
        <div
          data-testid={testId}
          className={cx(
            rootClassName,
            "relative bottom-0 left-0 top-0",
            "m-0 h-0 border-0"
          )}
          style={{
            paddingBottom: paddingBottom,
          }}
          data-annotation={annotation}
          data-aspectRatio={sourceData.data[3].value}
          data-tablet-aspectRatio={sourceData.data[4].value}
          data-mobile-aspectRatio={sourceData.data[5].value}
        >
          <iframe
            className={cx(
              "ceros-experience absolute bottom-0 left-0 top-0 overflow-hidden",
              "m-0 min-h-full min-w-full border-0"
            )}
            title={sourceData.data[2].value}
            src={sourceData.data[0].value}
          ></iframe>
        </div>
      ) : null}
    </>
  );
}
